// extracted by mini-css-extract-plugin
export default {"verify-body":"q4SJ","resend":"i03D","button-container":"QpU1"};